import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';

const ReimbursementService = {
    async setReimbursement(userId, data) {
        const { sortCode, accountNumber, method, paypalEmail, charity } = data;
        try {
            await AuthenticatedAPIClient.put(`/delay-repay/auto/customer/${userId}/reimbursement`, {
                method,
                sortCode,
                accountNumber,
                paypalEmail,
                charity,
            });
            return true;
        } catch (e) {
            console.warn('error saving reimbursement preference', e);
            return false;
        }
    },

    async getReimbursement(userId) {
        try {
            const response = await AuthenticatedAPIClient.get(`/delay-repay/auto/customer/${userId}/reimbursement`);
            return response;
        } catch (e) {
            console.warn('error getting reimbursement preference', e);
            return false;
        }
    }
};

export default ReimbursementService;


